var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFlip = function SvgFlip(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "13 14.5 15 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "flip_svg__a_CC5TOSEI",
    d: "M0 0h44v44H0Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    transform: "translate(14 13)",
    d: "M10.5 16.364h1.667v-1.637H10.5v1.637Zm3.333-9.819H15.5V4.91h-1.667v1.636ZM.5 3.273v11.454c0 .9.75 1.637 1.667 1.637H5.5v-1.637H2.167V3.273H5.5V1.636H2.167C1.25 1.636.5 2.373.5 3.273Zm13.333-1.637v1.637H15.5c0-.9-.75-1.637-1.667-1.637ZM7.167 18h1.666V0H7.167v18Zm6.666-4.91H15.5v-1.636h-1.667v1.637ZM10.5 3.274h1.667V1.636H10.5v1.637Zm3.333 6.545H15.5V8.182h-1.667v1.636Zm0 6.546c.917 0 1.667-.737 1.667-1.637h-1.667v1.637Z",
    style: {
      fill: "currentColor"
    }
  }));
};
export default SvgFlip;